export type TDropdown = {
    id: number;
    name: string;
};

export type TListState<T> = {
    data: T[];
    loading: boolean;
    count: number;
};
export const EmptyList = { data: [], loading: false, count: 0 };

export type TFormState<T> = {
    open: boolean;
    data: T;
};